import {
  withTranslation,
} from 'react-i18next';

import RegattaEntriesStatsSectionView from './RegattaEntriesStatsSectionView';

const TranslatedComponent = withTranslation()(RegattaEntriesStatsSectionView);

const Component = TranslatedComponent;

export default Component;
